// Just count the number of pages viewed during the session
// Useful for the Toastr notification that shouldn't show on the 1st page viewed
export default () => {
  try {
    // console.log('wild-pages-viewed', window.sessionStorage.getItem('wild-pages-viewed'));
    const total_pages_viewed = (window.sessionStorage.getItem('wild-pages-viewed') === null) ? 1 : Number(window.sessionStorage.getItem('wild-pages-viewed')) + 1;
    window.sessionStorage.setItem('wild-pages-viewed', total_pages_viewed);
  } catch (error) {
    console.log('Error detecting pages viewed', error);
  }
};
